module.exports = __webpack_public_path__ + "static/img/update.8b54fab5.png";